import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { FaChevronRight } from "react-icons/fa6";

function SvatbyProstory() {
  return (
    <div className="w-full overflow-x-hidden font-['Libre_Baskerville']">

      <Helmet>
        <title>Svatby – Prostory | Hospůdka pod Rablinů</title>
      </Helmet>

      {/* ================= MOBILE ================= */}
      <div className="block lg:hidden bg-[#f5e6c8]">
        <Navbar />

        <section className="px-6 pt-20 pb-16 text-left">
          <h1 className="text-3xl font-bold text-[#60260f] mb-10">
            PROSTORY PRO KONÁNÍ SVATEBNÍCH AKCÍ
          </h1>

          <p className="text-sm text-[#60260f] leading-relaxed mb-10 text-left">
            <b>Naše hospůdka je útulná dřevěná chalupa s rustikálním interiérem.</b><br/>
            Kapacita vnitřních prostor je až 100 osob a zahradní plochy pojmou dalších 200 hostů.
          </p>

          <div className="space-y-6">
            <img src="./img/restaurace/restaurace-6.jpg" className="w-full rounded-lg" alt="Prostory restaurace pro svatby" />
            <img src="./img/svatby.jpg" className="w-full rounded-lg" alt="Svatební hostina v Hospůdce pod Rablinů" />
            <img src="./img/restaurace/restaurace-2.jpg" className="w-full rounded-lg" alt="Interiér svatebních prostor" />
          </div>

          <div className="mt-12 flex flex-col gap-6">
            <Link to="/rezervace-ubytovani">
              <button className="w-full py-4 rounded-xl border border-black text-[#60260f] bg-white">
                Rezervace ubytování
              </button>
            </Link>

            <Link to="/rezervace-akce">
              <button className="w-full py-4 rounded-xl border border-black text-[#60260f] bg-white">
                Rezervace akcí
              </button>
            </Link>
          </div>
        </section>

        <Footer />
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="hidden lg:block">

        <Navbar />

        {/* NADPIS – SNÍŽENÝ DIV */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-5xl font-light text-[#60260f]">
            PROSTORY PRO KONÁNÍ SVATEB
          </h1>
        </section>

        {/* GALERIE 1 – MEZERY */}
        <section className="flex gap-6 px-6 h-[45vh]">
          <img src="./img/restaurace/restaurace-6.jpg" className="w-[calc(33.333%-1rem)] object-cover rounded-lg" alt="Prostory restaurace pro svatby" />
          <img src="./img/svatby.jpg" className="w-[calc(33.333%-1rem)] object-cover rounded-lg" alt="Svatební hostina v Hospůdce pod Rablinů" />
          <img src="./img/restaurace/restaurace-2.jpg" className="w-[calc(33.333%-1rem)] object-cover rounded-lg" alt="Interiér svatebních prostor" />
        </section>

        {/* TEXT */}
        <section className="max-w-5xl mx-auto py-28 px-10 text-center text-[#60260f] leading-relaxed">
          <p className="text-lg">
            <b className="block mb-6 text-xl">
              Naše hospůdka je útulná dřevěná chalupa s rustikálním interiérem.
            </b>
            Kapacita vnitřních prostor je až 100 osob a zahradní plochy pojmou
            dalších 200 hostů.
          </p>
        </section>

        {/* CTA */}
        <section className="bg-[#faf0d9] border-y border-black py-24 text-center">
          <p className="text-2xl text-[#60260f] mb-2">Zamluvte si termín</p>
          <p className="mb-10 text-[#60260f]">Na pár kliknutí</p>

          <div className="flex justify-center gap-10">
            <Link to="/rezervace-ubytovani">
              <button className="px-10 py-4 rounded-xl border border-black text-[#60260f] hover:bg-[#60260f] hover:text-white transition">
                Rezervace ubytování
              </button>
            </Link>

            <Link to="/rezervace-akce">
              <button className="px-10 py-4 rounded-xl border border-black text-[#60260f] hover:bg-[#60260f] hover:text-white transition">
                Rezervace akcí
              </button>
            </Link>
          </div>
        </section>

        {/* GALERIE 2 */}
        <section className="flex gap-6 px-6 h-[45vh] mt-24">
          <img src="./img/svatba-rablina-exterior-1.jpg" className="w-[calc(33.333%-1rem)] object-cover rounded-lg" alt="Svatební exteriér" />
          <img src="./img/svatby-venku-1.jpg" className="w-[calc(33.333%-1rem)] object-cover rounded-lg" alt="Venkovní svatební obřad" />
          <img src="./img/main-fotka-venku.jpg" className="w-[calc(33.333%-1rem)] object-cover rounded-lg" alt="Venkovní areál Hospůdky pod Rablinů" />
        </section>

        {/* ODKAZ */}
        <section className="py-24 text-center">
          <Link to="/svatby-fotogalerie" className="inline-flex items-center gap-3 text-xl text-[#60260f] hover:underline">
            Více z fotografií <FaChevronRight />
          </Link>
        </section>

        <Footer />
      </div>
    </div>
  );
}

export default SvatbyProstory;
